import React from 'react';
import { connect } from 'react-redux';

import { goTo } from '../tools';
import { movil } from '../app-movil';
import isMobile from 'ismobilejs';

// import PolizaForm from './poliza.frm';

const mapState = (state) => {
    return {
        correo: state.olvide.correo,
        url: state.olvide.url
    };
}

const mapDispatch = (dispatch) => {
    return {
        pasoAnterior: () => {
            console.log("a");
            dispatch({ "type": "OLVIDE_SET_CORREO", "correo": "" });
            dispatch({ "type": "OLVIDE_PASO_ANTERIOR" });
        },
        resetPaso: () => {
            dispatch({ "type": "OLVIDE_RESET_PASO" });
        }
    }
}

class RevisaCorreo extends React.Component {
    regresar = () => {
        let mensaje = {"return": "login", "procesa": "recupera"};
        movil("cambiarcontrasena", mensaje);
        this.props.resetPaso();
        goTo("login");
        //window.location.href = '/#!/login';
    }

    render() {
        return <div className="login-form">
            <div className="text-center">
                { !isMobile.any &&
                <a className="pull-left" onClick={this.props.pasoAnterior}>
                    <img src={ require("../img/arrow-back.png") } alt="" />
                </a>
                }
                <img src={ require("../img/logo-gnp.svg") } alt="" />
            </div>
            <h3 className="text-center">Revisa tu correo electrónico</h3>
            <div className="mt-25 text-center texto-17">
                <p>Haz clic en el enlace dentro del correo para restablecer tu contraseña.</p>
                 <p>Si no ves el correo electrónico en tu bandeja de entrada revisa otras <br className="hide-mobile" />carpetas como spam.</p>
                {/*<p>Liga Temporal: <a onClick={this.getUrl}>Aquí</a></p>*/}
            </div>
            <span className="gray-text reenviar">{/*No he recibido el correo. <a className="black-text" onClick={this.props.pasoAnterior}>Reenviar</a>*/}</span>
            <a onClick={this.regresar} className="mt-70">
                <button className="orange-circle">
                    <i></i>
                </button>
            </a>
        </div>
	}
}

export default connect(mapState, mapDispatch)(RevisaCorreo);


// WEBPACK FOOTER //
// ./src/olvide/revisaCorreo.cmpt.js